<template>
	<v-container px-0 pb-0>
	<v-layout justify-space-around>
	<v-flex xs11 sm9 md6 text-xs-center text-md-left>
		<router-link to="/">
			<img src="img/RGB_formal_Sauer_Lab.jpeg" class="icon">
		</router-link>
	</v-flex>
	<v-flex md6 class="hidden-sm-and-down">
		
	</v-flex>
	</v-layout>
	</v-container>

	
</template>

<script>
export default {
  name: 'logo',
  data () {
    return {
	
    }
  },
  methods:{
		
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
	height:auto;
	max-width:100%;
	display:inline-block;
	margin: 5px 5px 5px 5px;
}
.head-wrap{
	background-color:rgb(191, 87, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue